export default [
  {
    path: '/news',
    name: 'news',
    component: () => import('@/views/news/MessageScreen.vue'),
    meta: {
      title: 'app_msg'
    }
  },
  {
    path: '/newsDetail/:code/:name',
    name: 'newsDetail',
    component: () => import('@/views/news/SystemNotice.vue'),
    meta: {
      title: 'app_msg_detail',
      pageLevel: 2
    }
  }
]
